"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EulaScreenBase = void 0;
var react_1 = __importStar(require("react"));
var WorkflowCard_1 = require("../../components/WorkflowCard");
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var dompurify_1 = __importDefault(require("dompurify"));
var ErrorManager_1 = __importDefault(require("../../components/Error/ErrorManager"));
var material_1 = require("@mui/material");
var ReplaySharp_1 = __importDefault(require("@mui/icons-material/ReplaySharp"));
/**
 * Component that renders a screen displaying the EULA and requests acceptance via a checkbox.
 *
 * @param eulaContent the content to render for the EULA. Can be a plain string or HTML
 * @param html true if the EULA should be rendered as HTML
 * @param checkboxLabel label for the EULA checkbox
 * @param initialCheckboxValue used to pre-populate the checked/unchecked checkbox when the screen loads
 * @param checkboxProps used to set checkbox props
 * @param onEulaAcceptedChange called when the checkbox clicked
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 * @param onRefetch used to refetch Eula content.
 *
 * @category Component
 */
var EulaScreenBase = function (props) {
    var onEulaAcceptedChange = props.onEulaAcceptedChange, eulaContent = props.eulaContent, checkboxLabel = props.checkboxLabel, html = props.html, initialCheckboxValue = props.initialCheckboxValue, checkboxProps = props.checkboxProps, errorDisplayConfig = props.errorDisplayConfig, onRefetch = props.onRefetch;
    var cardBaseProps = props.WorkflowCardBaseProps || {};
    var headerProps = props.WorkflowCardHeaderProps || {};
    var instructionsProps = props.WorkflowCardInstructionProps || {};
    var actionsProps = props.WorkflowCardActionsProps || {};
    var _a = (0, react_1.useState)(initialCheckboxValue !== null && initialCheckboxValue !== void 0 ? initialCheckboxValue : false), eulaAccepted = _a[0], setEulaAccepted = _a[1];
    var handleEulaAcceptedChecked = (0, react_1.useCallback)(function (accepted) {
        setEulaAccepted(accepted);
        onEulaAcceptedChange === null || onEulaAcceptedChange === void 0 ? void 0 : onEulaAcceptedChange(accepted);
    }, [onEulaAcceptedChange]);
    var handleOnNext = function () {
        var onNext = actionsProps.onNext;
        if (onNext)
            onNext({ accepted: eulaAccepted });
    };
    return (react_1.default.createElement(WorkflowCard_1.WorkflowCard, __assign({}, cardBaseProps),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardHeader, __assign({}, headerProps)),
        Object.keys(instructionsProps).length !== 0 && react_1.default.createElement(WorkflowCard_1.WorkflowCardInstructions, __assign({}, instructionsProps)),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardBody, { sx: { pt: 2 } },
            (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.disabled) ? (react_1.default.createElement(Box_1.default, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                } },
                react_1.default.createElement(Box_1.default, { sx: {
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        p: 1,
                    }, onClick: onRefetch },
                    react_1.default.createElement(ReplaySharp_1.default, { color: "primary", sx: { width: 36, height: 36 } }),
                    react_1.default.createElement(material_1.Typography, { variant: "subtitle2", color: "primary" }, "Retry")))) : html ? (react_1.default.createElement(Box_1.default, { sx: { flex: '1 1 0', overflow: 'auto' }, dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(eulaContent) } })) : (react_1.default.createElement(Box_1.default, { sx: { flex: '1 1 0', overflow: 'auto' } }, eulaContent)),
            react_1.default.createElement(ErrorManager_1.default, __assign({}, errorDisplayConfig),
                react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, __assign({ color: 'primary', checked: eulaAccepted, onChange: function (event) {
                            return handleEulaAcceptedChecked(event.target.checked);
                        } }, checkboxProps)), label: checkboxLabel, sx: { flex: '0 0 auto', mr: 0, mt: 2 }, onKeyUp: function (e) {
                        if (e.key === 'Enter' && eulaAccepted)
                            handleOnNext();
                    } }))),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardActions, __assign({}, actionsProps, { canGoNext: eulaAccepted && actionsProps.canGoNext }))));
};
exports.EulaScreenBase = EulaScreenBase;
